import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import MUIDataTable, { MUIDataTableOptions } from 'mui-datatables';
import React from 'react';
import { InvoiceProps } from '../models/InvoiceProps';
import { withLineBreaks } from '../utils/utils';

const tableData = (items: any[]) => {

    return items.map((item) => {
      const { description, quantity, amount} = item
      const { amountExVat, amountIncVat, vatRate } = amount;
  
      return ([withLineBreaks(description),
        quantity,
        amountIncVat !== 0 ? amountIncVat.toFixed(2) : amountIncVat,
        amountExVat !== 0 ? amountExVat.toFixed(2) : amountExVat,
        vatRate.description])
    });
}

const columns = ["Description", "Quantity", "Amount Inc Vat", "Amount Ex Vat", "VAT"];

const options: MUIDataTableOptions = {
    print: false,
    pagination: false,
    search: false,
    download: false,
    filter: false,
    viewColumns: false,
    sort: false,
    selectableRowsHideCheckboxes: true,
    responsive: 'simple'   
};

const getMuiTheme = () => createMuiTheme({
  overrides: {
      MuiPaper:{
        elevation4: {
          boxShadow: 'none', 
          marginTop: '10px'
        }
      },
      MuiTableCell: {
        body:{
          '& > *': {
            fontSize: '0.8rem !important'
          }
        },
        root: 
        {
          '@media print': {
            padding: '8px !important',
        }
        },
        head: {
          paddingTop: '0px !important',
          paddingBottom: '8px !important',
        }
      },
      MuiTableRow: {
        root: {
          '&:nth-child(odd)': { 
            backgroundColor: '#f6f8fa'
          }
        }
      }
    }
});

const InvoiceTable: React.FunctionComponent<InvoiceProps> = ({ invoice }) => {
    const { items } = invoice!;

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            title={""}
            data={tableData(items)}
            columns={columns}
            options={options}
          /> 
      </MuiThemeProvider>
    )
}

export default InvoiceTable;